import { CustomEventWithDefaults } from './custom-event-with-defaults.js';

class CrntBlurEvent extends CustomEventWithDefaults {
  constructor() {
    super("crnt-blur");
  }
}

export { CrntBlurEvent };
